// extracted by mini-css-extract-plugin
export default {"container":"ReverseStrikeOffVoter_container__wmUrz","title":"ReverseStrikeOffVoter_title__gXaSC","section":"ReverseStrikeOffVoter_section__oErBy"};